import { Button, Dialog } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import useDialogAriaHidden from '../../hooks/useDialogAriaHidden';

export function NoteModals({
    showModal = false,
    extraClass = '',
    heading = 'NOTE',
    info = '',
    proceedBtn = '',
    cancelBtn = '',
    proceedHref = '',
    mobileOrEmail = '',
    onCancel = () => {},
    ...props
}) {
    const [show, setShow] = useState<boolean>(showModal);
    const headingRef = useRef<HTMLHeadingElement>(null);
    const headingId = 'note-modals-heading';

    useEffect(() => {
        setShow(showModal);
        if (showModal) {
            headingRef.current?.focus();
        }
    }, [showModal]);

    useDialogAriaHidden(show);

    const onProceed = () => {
        if (!!props.onProceed && typeof props.onProceed === 'function') {
            props.onProceed();
            return;
        }
        props.push(proceedHref);
    };

    return (
        <Dialog
            maxWidth={'sm'}
            open={show}
            role="dialog"
            aria-modal="true"
            aria-labelledby={headingId}
        >
            <div className={`note-modals ${extraClass}`}>
                <h3 id={headingId} ref={headingRef} tabIndex={-1}>
                    {heading}
                </h3>
                <p>
                    {info} {mobileOrEmail}
                </p>
                <div className="note-modals-btns">
                    <Button className="customBtn" onClick={onProceed}>
                        {proceedBtn}
                    </Button>
                    {!!cancelBtn && (
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() => {
                                setShow(!show);
                                onCancel();
                            }}
                        >
                            {cancelBtn}
                        </Button>
                    )}
                </div>
            </div>
        </Dialog>
    );
}
